import { lazy, LazyExoticComponent } from 'react';

const MainLayout = lazy(() => import('./../common/layouts/main'));

export interface RouteSpec {
  layout: LazyExoticComponent<() => JSX.Element> | (() => JSX.Element);
  group?: string;
  pages: string;
  index?: true;
}

const routes: Readonly<Record<string, RouteSpec>> = {
  NOS: {
    layout: MainLayout,
    group: 'main',
    pages: 'nos/*',
  },
  NGR: {
    layout: MainLayout,
    group: 'main',
    pages: 'ngr/*',
  },
  ReportLayout: {
    layout: MainLayout,
    group: 'main',
    pages: 'ngr/report/*',
  },
  NGI: {
    layout: MainLayout,
    group: 'main',
    pages: 'ngi/*',
  },
  notifications: {
    layout: MainLayout,
    group: 'main',
    pages: 'notifications/*',
  },
  support: {
    layout: MainLayout,
    group: 'main',
    pages: 'support/*',
  },
} as const;

export default routes;
